import(/* webpackMode: "eager" */ "/home/ubuntu/download/69695302c9f2cb0014de4538/golfconnect/src/app/login/page.tsx");
